import { Box } from '@mui/material';

const lockup = {
  light: '/brand/ncpl-lockup.png',
  dark: '/brand/ncpl-lockup-on-dark.png',
};

const mark = {
  light: '/brand/ncpl-mark.png',
  dark: '/brand/ncpl-mark-on-dark.png',
};

export default function NcplLogo({ variant = 'light', showWordmark = true, compact = false, height }) {
  const tone = variant === 'dark' ? 'dark' : 'light';
  const src = showWordmark ? lockup[tone] : mark[tone];
  const resolvedHeight = height || (showWordmark
    ? compact
      ? 40
      : { xs: 44, md: 56 }
    : compact
      ? 36
      : 44);

  return (
    <Box
      component="img"
      src={src}
      alt="Narayanee Clothing Pvt. Ltd."
      width={showWordmark ? 1600 : 800}
      height={showWordmark ? 425 : 703}
      sx={{
        height: resolvedHeight,
        width: 'auto',
        maxWidth: '100%',
        display: 'block',
        objectFit: 'contain',
        objectPosition: 'left center',
      }}
    />
  );
}
